




































import { computed, defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/BaseIcon";
import BaseImage from "@/components/BaseImage";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "DocumentPreview",
  components: { BaseIcon, BaseImage, BaseSpinner },
  props: {
    size: { type: [String, Number], default: "122px" },
    alt: { type: String },
    loading: { type: Boolean, default: false },
    remove: { type: Boolean, default: false },
  },
  setup(props) {
    const styleSize = computed(() => {
      return typeof props.size === "number" ? `${props.size}px` : props.size;
    });
    return {
      styleSize,
    };
  },
});
